import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const WhatsAppFloatingButton = () => {
  const message = encodeURIComponent(
    "Hi! I'm interested in your stock market courses. Please share more details. 📈"
  );

  return (
    <a
      href={`https://wa.me/918421422215?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: "fixed",
        bottom: "13%",
        right: 10,
        backgroundColor: "#25D366",
        padding: 10,
        borderRadius: "50%",
        zIndex: 9999,
        color: "#fff",
        boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
      }}
    >
      <WhatsAppIcon style={{ fontSize: 32 }} />
    </a>
  );
};

export default WhatsAppFloatingButton;
